import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=71f4a4b9"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f4a4b9')) {
      api.createRecord('71f4a4b9', component.options)
    } else {
      api.reload('71f4a4b9', component.options)
    }
    module.hot.accept("./Form2.vue?vue&type=template&id=71f4a4b9", function () {
      api.rerender('71f4a4b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/FENORESTE/CSN/Form2.vue"
export default component.exports